"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    attrs: {
      "return-menu": "/farm-management/dashboard",
      menu: _vm.page.children,
      subtitle: _vm.page.meta.title
    },
    scopedSlots: _vm._u([{
      key: "context",
      fn: function fn() {
        var _vm$selectedLot$roots;
        return [_c("section", {
          staticClass: "partial-graft-lot-page"
        }, [_c("header", {
          staticClass: "page-header"
        }, [_c("h1", {
          staticClass: "page-title"
        }, [_vm._v("\n          Enxertia Parcial\n        ")]), _vm._v(" "), _vm.selectedLot ? _c("b-button", {
          staticClass: "plant-nursery-primary-btn",
          attrs: {
            type: "is-primary"
          },
          on: {
            click: _vm.clearSelection
          }
        }, [_c("span", {
          staticClass: "icon"
        }, [_c("i", {
          staticClass: "icon-ic_voltar"
        })]), _vm._v(" "), _c("span", [_vm._v("Voltar para seleção")])]) : _vm._e()], 1), _vm._v(" "), !_vm.selectedLot ? _c("div", {
          staticClass: "page-content"
        }, [_c("h3", {
          staticClass: "section-title"
        }, [_vm._v("\n          Selecione um lote para enxertia parcial\n        ")]), _vm._v(" "), _c("LotsList", {
          attrs: {
            lots: _vm.lots,
            "is-loading": _vm.isLoadingLots
          },
          on: {
            onSearchChange: _vm.handleLotsSearch
          },
          model: {
            value: _vm.selectedLot,
            callback: function callback($$v) {
              _vm.selectedLot = $$v;
            },
            expression: "selectedLot"
          }
        })], 1) : _c("div", {
          staticClass: "page-content"
        }, [_c("div", {
          staticClass: "selected-lot-info"
        }, [_c("h3", {
          staticClass: "section-title"
        }, [_vm._v("\n            Lote selecionado: " + _vm._s(_vm.selectedLot.code) + "\n          ")]), _vm._v(" "), _c("p", {
          staticClass: "lot-details"
        }, [_c("strong", [_vm._v("Porta-enxerto:")]), _vm._v(" " + _vm._s(((_vm$selectedLot$roots = _vm.selectedLot.rootstock) === null || _vm$selectedLot$roots === void 0 ? void 0 : _vm$selectedLot$roots.name) || "--") + "\n          ")])]), _vm._v(" "), _c("form", {
          on: {
            submit: function submit($event) {
              $event.preventDefault();
              return _vm.submitForm.apply(null, arguments);
            }
          }
        }, [_c("div", {
          staticClass: "form-section"
        }, [_c("h3", {
          staticClass: "section-title"
        }, [_vm._v("\n              Definir copa\n            ")]), _vm._v(" "), _c("div", {
          staticClass: "form-row"
        }, [_c("b-field", {
          staticClass: "form-field",
          attrs: {
            label: "Copa"
          }
        }, [_c("b-select", {
          attrs: {
            placeholder: "Selecione a copa",
            expanded: "",
            required: ""
          },
          model: {
            value: _vm.form.scionId,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "scionId", $$v);
            },
            expression: "form.scionId"
          }
        }, [_c("option", {
          domProps: {
            value: null
          }
        }, [_vm._v("\n                    Selecione\n                  ")]), _vm._v(" "), _vm._l(_vm.scionVarieties, function (variety) {
          return _c("option", {
            key: variety.id,
            domProps: {
              value: variety.id
            }
          }, [_vm._v("\n                    " + _vm._s(variety.name) + "\n                  ")]);
        })], 2)], 1), _vm._v(" "), _c("b-field", {
          staticClass: "form-field",
          attrs: {
            label: "Data da enxertia"
          }
        }, [_c("b-datepicker", {
          attrs: {
            placeholder: "Selecione a data",
            icon: "calendar-today",
            required: ""
          },
          model: {
            value: _vm.form.graftAt,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "graftAt", $$v);
            },
            expression: "form.graftAt"
          }
        })], 1)], 1)]), _vm._v(" "), _c("div", {
          staticClass: "form-section"
        }, [_c("LotInventorySelector", {
          attrs: {
            inventories: _vm.selectedLot.inventories || [],
            label: "Selecione as quantidades para enxertar",
            "quantity-label": "Quantidade a enxertar",
            "quantity-placeholder": "Qtd.",
            "empty-message": "Este lote não possui inventários disponíveis."
          },
          model: {
            value: _vm.form.senderInventories,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "senderInventories", $$v);
            },
            expression: "form.senderInventories"
          }
        })], 1), _vm._v(" "), _c("div", {
          staticClass: "form-section"
        }, [_c("h3", {
          staticClass: "section-title"
        }, [_vm._v("\n              Lote de destino\n            ")]), _vm._v(" "), _c("AutocompleteSelect", {
          key: _vm.form.scionId || "no-scion",
          attrs: {
            items: _vm.receiverLotItems,
            "on-fetch": _vm.fetchReceiverLots,
            label: "Lote receptor",
            placeholder: "Buscar lote para receber as mudas enxertadas...",
            "selection-property": "id",
            "label-property": "code",
            multiple: false,
            "show-selected-list": false
          },
          on: {
            input: _vm.onReceiverLotChange
          },
          model: {
            value: _vm.form.receiverLotId,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "receiverLotId", $$v);
            },
            expression: "form.receiverLotId"
          }
        }), _vm._v(" "), _c("div", {
          staticClass: "receiver-inventory-selector"
        }, [_vm.receiverLot ? _c("LotInventorySelector", {
          attrs: {
            inventories: _vm.receiverLot.inventories || [],
            label: "Locais de destino",
            "quantity-label": "Quantidade a receber",
            "quantity-placeholder": "Qtd.",
            "empty-message": "Este lote não possui inventários disponíveis."
          },
          model: {
            value: _vm.form.receiverInventories,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "receiverInventories", $$v);
            },
            expression: "form.receiverInventories"
          }
        }) : _vm._e()], 1), _vm._v(" "), _vm.quantityMismatch ? _c("div", {
          staticClass: "quantity-alert"
        }, [_c("b-message", {
          attrs: {
            type: "is-warning",
            "has-icon": ""
          }
        }, [_c("strong", [_vm._v("Atenção:")]), _vm._v(" Quantidade de origem (" + _vm._s(_vm.senderTotal) + ") diferente da\n                quantidade de destino (" + _vm._s(_vm.receiverTotal) + "). As quantidades devem ser iguais.\n              ")])], 1) : _vm._e()], 1), _vm._v(" "), _c("div", {
          staticClass: "form-actions"
        }, [_c("b-button", {
          staticClass: "plant-nursery-primary-btn",
          attrs: {
            "native-type": "submit",
            type: "is-primary",
            loading: _vm.isSubmitting,
            disabled: _vm.isSubmitting || _vm.quantityMismatch
          }
        }, [_vm._v("\n              Realizar enxertia parcial\n            ")]), _vm._v(" "), _c("b-button", {
          attrs: {
            type: "is-text",
            disabled: _vm.isSubmitting
          },
          on: {
            click: _vm.handleCancel
          }
        }, [_vm._v("\n              Cancelar\n            ")])], 1)])])])];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;